import type {RouteConfigType} from './route-config-type';

/**
 * While phasing out the Ember Router we have to keep this common config that both routers refer to.
 * This is due to Ember not letting any traffic through to routes it doesn't know about
 */
export const RouteConfig = {
    welcome: {path: '/welcome/:token', crew: 'aim'},
    invitation: {
        path: '/invitation',
        subRoutes: {
            challenge: {
                path: '/:roleInvitationId',
                crew: 'aim',
            },
            accepted: {
                path: '/accepted',
                crew: 'aim',
            },
            denied: {
                path: '/denied',
                crew: 'aim',
            },
        },
        crew: 'aim',
    },
    famlyLiveJoinMeeting: {path: '/famlyLive/joinMeeting', crew: 'aim'},
    famlyLiveMeetingLeft: {path: '/famlyLiveMeetingLeft', crew: 'aim'},
    forgotPassword: {path: '/forgotPassword', crew: 'aim'},
    signup: {path: '/signup', crew: 'growth'},
    debugger: {
        path: '/debugger',
        crew: 'aim',
        subRoutes: {
            loginWithAccessToken: {
                path: '/loginWithAccessToken',
                crew: 'aim',
            },
        },
    },
    icons: {path: '/icons', crew: 'aim'},
    inquiry: {path: '/inquiry', crew: 'stat'},
    contextChallenge: {path: '/contextChallenge', crew: 'aim'},
    testLogin: {path: '/testLogin', crew: 'aim'},
    errorTest: {path: '/errorTest', crew: 'aim'},
    errorLog: {path: '/errorLog', crew: 'aim'},
    connectTokenSent: {path: '/connectTokenSent', crew: 'aim'},
    resetPassword: {path: '/resetPassword', crew: 'aim'},
    oneTimeLogin: {path: '/one-time-login', crew: 'aim'},
    confirmEmail: {path: '/confirmEmail', crew: 'aim'},
    newAccount: {path: '/newAccount', crew: 'aim'},
    notFound: {path: '/notFound', crew: 'aim'},
    customInquiryForm: {
        path: '/customInquiryForm/:formId/to/:siteSetId',
        crew: 'stat',
        subRoutes: {
            // Private route
            preview: {
                path: '/preview',
                crew: 'stat',
            },
            // Public route
            submit: {
                path: '/submit',
                crew: 'stat',
            },
        },
    },
    tooManyFailedLoginAttempts: {
        path: '/tooManyFailedLoginAttempts',
        crew: 'aim',
    },
    contract: {path: '/contract', crew: 'aim'},
    unavailable: {path: '/unavailable', crew: 'aim'},
    login: {path: '/login', crew: 'aim'},
    offer: {path: '/offer/:id', crew: 'growth'},
    emailVerification: {
        path: '/emailVerification/:verificationCode/to/:siteSetId',
        crew: 'aim',
    },
    newSiteRequest: {path: '/newSiteRequest', crew: 'growth'},

    // Open id
    openid: {
        path: '/openid',
        crew: 'aim',
        subRoutes: {
            // Route used as callback when authenticating with an OIDC provider
            redirect: {
                path: '/redirect',
                crew: 'aim',
            },
            // Used for connecting a Famly account with an OIDC account
            connect: {
                path: '/connect',
                crew: 'aim',
            },
            // Route used as callback when connecting your a Famly account with an OIDC account
            connectCallback: {
                path: '/connectCallback',
                crew: 'aim',
            },
            // Used for authenticating with a token - used for e.g. changing pin codes (for OIDC users)
            tokenCallback: {
                path: '/tokenCallback',
                crew: 'aim',
            },
        },
    },

    /*
    |---------------------------------------------------------------------------------
    | Account routes
    |---------------------------------------------------------------------------------
    */
    account: {
        path: '/account',
        crew: 'aim',
        subRoutes: {
            event: {path: '/event/:eventId', crew: 'aim'},
            newWeekPlan: {path: '/newWeekPlan', crew: 'aim'},
            calendar: {
                path: '/calendar',
                crew: 'aim',
                subRoutes: {
                    me: {path: '/me', crew: 'aim'},
                },
            },
            activities: {
                path: '/activities',
                crew: 'aim',
                subRoutes: {
                    library: {path: '/library/:libraryId', crew: 'aim'},
                    activity: {path: '/activity/:id', crew: 'aim'},
                },
            },
            inbox: {path: '/inbox', crew: 'aim'},
            dataExports: {path: '/dataExports', crew: 'aim'},
            moreMenu: {path: '/moreMenu', crew: 'aim'},
            navigationV2MobileMenu: {
                path: '/navigationV2MobileMenu',
                crew: 'aim',
                subRoutes: {
                    navigationGroup: {
                        path: '/navigationGroup/:groupId',
                        crew: 'aim',
                    },
                },
            },
            billingOverview: {path: '/billingOverview', crew: 'finance'},
            post: {
                path: '/post/:postId',
                crew: 'aim',
                subRoutes: {
                    comments: {path: '/comments', crew: 'aim'},
                },
            },
            // Legacy route for keeping links in notification emails working
            posts: {
                path: '/posts/:postId',
                crew: 'aim',
                subRoutes: {
                    comments: {path: '/comments', crew: 'aim'},
                },
            },
            parentHome: {
                crew: 'stat',
                path: '/home',
                subRoutes: {
                    explore: {
                        path: '/explore',
                        crew: 'stat',
                    },
                    resourceCategories: {
                        path: '/resourceCategories/:resourceCategoryName',
                        crew: 'enr',
                    },
                    resource: {
                        path: '/resources/:resourceId',
                        crew: 'enr',
                    },
                },
            },
            feed: {
                path: '/feed',
                crew: 'aim',
                subRoutes: {
                    me: {path: '/me', crew: 'aim'},
                    bookmarks: {path: '/bookmarks', crew: 'aim'},
                },
            },
            // Lesson plans parent route
            lessonPlans: {path: '/lessonPlans', crew: 'aim'},
            notifications: {path: '/notifications', crew: 'aim'},
            balances: {path: '/balances/:loginId', crew: 'finance'},
            previousChildren: {path: '/previousChildren', crew: 'aim'},
            childVacationReply: {
                path: '/childVacationReply/:vacationId',
                crew: 'stat',
            },
            openid: {
                path: '/openid',
                crew: 'aim',
                subRoutes: {
                    connect: {path: '/connect', crew: 'aim'},
                    createProvider: {path: '/createProvider', crew: 'aim'},
                },
            },
            childProfile: {
                path: '/childProfile/:childId',
                crew: 'aim',
                subRoutes: {
                    activity: {path: '/activity', crew: 'aim'},
                    about: {path: '/about', crew: 'aim'},
                    sleep: {path: '/sleep', crew: 'aim'},
                    institutionInfo: {path: '/institutionInfo', crew: 'aim'},
                    leave: {path: '/leave', crew: 'stat'},
                    photos: {path: '/photos', crew: 'aim'},
                    childProfilePlans: {path: '/childProfilePlans', crew: 'finance'}, // this route just redirects to /plansAndInvoices
                    childProfileBilling: {
                        path: '/childProfileBilling',
                        crew: 'finance',
                    }, // this route just redirects to /plansAndInvoices
                    childProfileRelations: {
                        path: '/childProfileRelations',
                        crew: 'aim',
                    },
                    plansAndInvoices: {path: '/plansAndInvoices', crew: 'finance'},
                    childProfileNotes: {
                        path: '/childProfileNotes',
                        crew: 'aim',
                        subRoutes: {
                            index: {
                                path: '/',
                                crew: 'aim',
                            },
                            note: {
                                path: '/:noteId',
                                crew: 'aim',
                            },
                        },
                    },
                    childProfileLearningJourney: {
                        path: '/childProfileLearningJourney',
                        crew: 'aim',
                        subRoutes: {
                            index: {
                                path: '/',
                                crew: 'aim',
                            },
                            observation: {
                                path: '/:observationId',
                                crew: 'aim',
                            },
                        },
                    },
                    childProfileLearningJourneyDetails: {
                        path: '/childProfileLearningJourneyDetails',
                        crew: 'aim',
                    },
                    safeguarding: {
                        path: '/safeguarding',
                        crew: 'aim',
                    },
                    family: {
                        path: '/family',
                        crew: 'aim',
                    },
                    printPreview: {
                        path: '/printPreview',
                        crew: 'growth',
                    },
                },
            },
            settings: {
                path: '/settings',
                crew: 'aim',
                subRoutes: {
                    customCareGroups: {path: '/customCareGroups/:customCareGroupId', crew: 'stat'},
                    ageGroups: {path: '/ageGroups/:institutionId', crew: 'stat'},
                },
            },
            accountSettings: {
                path: '/accountSettings',
                crew: 'aim',
                subRoutes: {
                    accountDetails: {path: '/accountDetails', crew: 'aim'},
                    accountNotifications: {
                        path: '/accountNotifications',
                        crew: 'aim',
                    },
                    accountPassword: {path: '/accountPassword', crew: 'aim'},
                    accountPincode: {path: '/accountPincode', crew: 'aim'},
                    paymentDetails: {path: '/paymentDetails', crew: 'finance'},
                },
            },
            subscription: {path: '/subscription', crew: 'finance'},
            /*
                Since we added Famly Store to the institution routes, the link in the old nav was broken.
                This was due to different way of handling routes and nav links in the old and new nav.
                The solution is to keep both routes (at least for some time) until we are sure, nobody is on the old nav.
            */
            famlyStore: {
                path: '/famlyStore',
                subRoutes: {
                    packagePurchase: {
                        path: '/packagePurchase/:institutionId/:initialPackageId',
                        crew: 'growth',
                    },
                },
                crew: 'growth',
            },
            /*
                Sales to CS flow onboarding tool - customer led self-sign-up after accepting agreed contract (terms of deal)
                Read more about SCS flow here: https://www.notion.so/famly/Sales-to-CS-handover-681a34e59acc47d69f9573a32a41b80e
            */
            scsFlowOnboarding: {
                path: '/scsFlowOnboarding',
                crew: 'growth',
            },

            reports: {
                path: '/reports',
                crew: 'aim',
                subRoutes: {
                    overview: {
                        path: '/overview',
                        crew: 'aim',
                    },
                    lists: {
                        path: '/lists',
                        crew: 'aim',
                        subRoutes: {listFilter: {path: '/list-filter', crew: 'aim'}},
                    },
                    famlyInsights: {
                        path: '/famlyInsights',
                        crew: 'aim',
                    },
                    category: {
                        path: '/categories/:categoryId',
                        crew: 'aim',
                        subRoutes: {
                            report: {
                                path: '/reports/:reportId',
                                crew: 'aim',
                            },
                        },
                    },
                    report: {
                        path: '/report/:reportId',
                        crew: 'aim',
                    },
                    new: {
                        path: '/new',
                        crew: 'aim',
                        subRoutes: {
                            fromDataset: {
                                path: '/fromDataset/:datasetId',
                                crew: 'aim',
                            },
                            fromReportTemplate: {
                                path: '/fromReportTemplate/:reportTemplateId',
                                crew: 'aim',
                            },
                        },
                    },
                },
            },
            financeReports: {
                crew: 'aim',
                path: '/financeReports',
                subRoutes: {
                    report: {
                        crew: 'aim',
                        path: '/:reportId',
                    },
                },
            },
            learningReports: {
                crew: 'aim',
                path: '/learningReports',
                subRoutes: {
                    report: {
                        crew: 'aim',
                        path: '/:reportId',
                    },
                },
            },
            attendanceReports: {
                crew: 'aim',
                path: '/attendanceReports',
                subRoutes: {
                    report: {
                        crew: 'aim',
                        path: '/:reportId',
                    },
                },
            },
            /*
            |---------------------------------------------------------------------------------
            | Institution routes
            |---------------------------------------------------------------------------------
            */
            institution: {
                path: '/institution/:institutionId',
                crew: 'aim',
                subRoutes: {
                    home: {
                        crew: 'aim',
                        path: '/home',
                    },
                    newStartersOnboarding: {
                        crew: 'stat',
                        path: '/newStartersOnboarding',
                    },
                    homeCustomization: {
                        crew: 'aim',
                        path: '/customization',
                    },
                    activities: {
                        path: '/activities',
                        crew: 'aim',
                        subRoutes: {
                            library: {path: '/library/:libraryId', crew: 'aim'},
                            activity: {path: '/activity/:id', crew: 'aim'},
                        },
                    },
                    resourceLibrary: {
                        path: '/resourceLibrary',
                        crew: 'enr',
                        subRoutes: {
                            resource: {path: '/resource/:resourceId', crew: 'enr'},
                        },
                    },
                    contractTemplateBuilder: {
                        path: '/contract-template/:templateId',
                        crew: 'enr',
                    },
                    parentToDoLists: {
                        path: '/parentToDoLists',
                        crew: 'enr',
                        subRoutes: {
                            toDoList: {
                                path: '/list/:taskListId',
                                crew: 'enr',
                            },
                        },
                    },
                    feed: {
                        path: '/feed',
                        crew: 'aim',
                    },
                    calendar: {
                        path: '/calendar',
                        crew: 'stat',
                    },
                    parentalPermissions: {
                        path: '/permissions',
                        crew: 'aim',
                        subRoutes: {matrix: {path: '/matrix', crew: 'aim'}},
                    },
                    periodPlans: {
                        path: '/periodPlans',
                        crew: 'aim',
                        subRoutes: {group: {path: '/:childId', crew: 'aim'}},
                    },
                    lists: {
                        path: '/lists',
                        crew: 'aim',
                        subRoutes: {listFilter: {path: '/list-filter', crew: 'aim'}},
                    },
                    employeeTodos: {
                        path: '/employeeTodos',
                        crew: 'go',
                    },
                    institutionOverview: {
                        crew: 'aim',
                        path: '/',
                    },
                    institutionOverviewOld: {
                        crew: 'aim',
                        path: '/overview',
                    },
                    institutionOverviewParamerizedOld: {
                        path: '/overview/:type/:id/childrenAndStaff',
                        crew: 'aim',
                    },
                    childrenAndStaff: {
                        crew: 'aim',
                        path: '/:type/:id/childrenAndStaff',
                    },
                    subscription: {
                        crew: 'finance',
                        path: '/subscription',
                    },
                    mealPlan: {
                        path: '/mealPlan',
                        crew: 'aim',
                        subRoutes: {
                            oldVersion: {
                                path: '/oldVersion',
                                crew: 'aim',
                            },
                            createMealPlan: {
                                path: '/create',
                                crew: 'aim',
                            },
                            viewMealPlan: {
                                path: '/:mealPlanId',
                                crew: 'aim',
                            },
                        },
                    },
                    mealBooking: {
                        path: '/mealBooking',
                        crew: 'aim',
                    },
                    vacationPeriod: {
                        path: '/vacationPeriod/:vacationId',
                        crew: 'stat',
                    },
                    newDepartment: {
                        path: '/newDepartment',
                        crew: 'aim',
                    },
                    vacationPlanning: {
                        path: '/vacationPlanning',
                        crew: 'stat',
                    },
                    info: {
                        path: '/info',
                        crew: 'aim',
                    },
                    files: {
                        path: '/files',
                        crew: 'aim',
                        subRoutes: {
                            staffDocuments: {
                                path: '/staffDocuments',
                                crew: 'aim',
                            },
                            parentDocuments: {
                                path: '/parentDocuments',
                                crew: 'aim',
                            },
                            contractTemplates: {
                                path: '/contract-templates',
                                crew: 'enr',
                            },
                        },
                    },
                    editTag: {
                        path: '/editTag/:tagId',
                        crew: 'aim',
                    },
                    manageCheckinStatements: {
                        path: '/manageCheckinStatements',
                        crew: 'aim',
                    },
                    volumePricingSettings: {
                        path: '/volumePricingSettings',
                        crew: 'finance',
                    },
                    groupMoves: {
                        path: '/groupMoves',
                        crew: 'aim',
                    },
                    billPayerV2: {
                        path: '/billPayer/:billPayerId',
                        crew: 'finance',
                        subRoutes: {
                            // This only exists for legacy reasons where backend notifications linked to this subroute.
                            // This will keep Ember happy.
                            paymentMethods: {path: '/paymentMethods', crew: 'finance'},
                            taxStatement: {
                                path: '/taxStatement/:selectedYear',
                                crew: 'finance',
                            },
                        },
                    },
                    // TODO: Is this used?
                    accountingSettings: {
                        path: '/accountingSettings',
                        crew: 'finance',
                    },
                    publicFundingReport: {
                        path: '/publicFundingReport',
                        crew: 'finance',
                    },
                    childBasedFundingReport: {
                        path: '/funding',
                        crew: 'finance',
                    },
                    staffing: {
                        path: '/staffing',
                        crew: 'stat',
                        subRoutes: {
                            attendance: {
                                path: '/attendance',
                                crew: 'stat',
                            },
                            attendanceDetails: {
                                path: '/attendance/details',
                                crew: 'stat',
                            },
                            shiftPlanner: {path: '/staffSchedule', crew: 'stat'},
                            staffHours: {path: '/staffHours', crew: 'stat'},
                            staffLeaveV2: {path: '/staffLeaveV2', crew: 'stat'},
                            staffRatioReport: {path: '/staffRatioReport', crew: 'stat'},
                        },
                    },
                    attendance: {
                        path: '/attendance',
                        crew: 'stat',
                        subRoutes: {
                            kinderConnect: {
                                path: '/kinderConnect',
                                crew: 'stat',
                                subRoutes: {
                                    month: {
                                        path: '/:yearMonth',
                                        crew: 'stat',
                                        subRoutes: {
                                            export: {
                                                path: '/export',
                                                crew: 'stat',
                                            },
                                        },
                                    },
                                },
                            },
                        },
                    },
                    kitabuli: {
                        path: '/kitabuli',
                        crew: 'finance',
                    },
                    finance: {
                        path: '/finance',
                        crew: 'finance',
                    },
                    // TODO: Is this used?
                    financeReports: {
                        path: '/financeReports',
                        crew: 'finance',
                    },
                    // TODO: Is this used?
                    revenueAndDebt: {
                        path: '/revenueAndDebt',
                        crew: 'finance',
                    },
                    closingDays: {
                        path: '/closingDays',
                        crew: 'stat',
                    },
                    // TODO: Is this used?
                    revenueDetails: {
                        path: '/revenueDetails/:month',
                        crew: 'finance',
                    },
                    appReport: {
                        path: '/appReport',
                        crew: 'aim',
                    },
                    manageChildren: {
                        path: '/manageChildren',
                        crew: 'aim',
                    },
                    childOverview: {
                        path: '/childOverview',
                        crew: 'go',
                    },
                    paymentsSettings: {
                        path: '/paymentsSettings',
                        crew: 'finance',
                    },
                    revenueReport: {
                        path: '/revenueReport',
                        crew: 'finance',
                    },
                    debtCollection: {
                        path: '/debtCollection',
                        crew: 'payments',
                    },
                    payments: {
                        path: '/payments',
                        crew: 'finance',
                    },
                    invoicesReport: {
                        path: '/invoicesReport',
                        crew: 'finance',
                    },
                    billPayersReport: {
                        path: '/billPayersReport',
                        crew: 'finance',
                    },
                    depositsReport: {
                        path: '/depositsReport',
                        crew: 'finance',
                    },
                    directDebitsReport: {
                        path: '/directDebitsReport',
                        crew: 'finance',
                    },
                    inAppPaymentPayouts: {
                        path: '/inAppPaymentPayouts',
                        crew: 'payments',
                    },
                    subsidies: {
                        path: '/subsidies',
                        crew: 'growth',
                        subRoutes: {
                            addPayout: {
                                path: '/add-payout',
                                crew: 'growth',
                            },
                        },
                    },
                    // TODO: Get rid of this
                    apps: {
                        path: '/apps',
                        crew: 'aim',
                    },
                    batchInvoice: {
                        path: '/batchInvoice',
                        crew: 'finance',
                    },
                    occupancyPlanner: {
                        path: '/occupancyPlanner',
                        crew: 'stat',
                    },
                    childDevelopment: {
                        path: '/childDevelopment',
                        crew: 'aim',
                        subRoutes: {
                            progressReport: {path: '/progressReport', crew: 'aim'},
                            cohortCompare: {path: '/cohortCompare', crew: 'aim'},
                            nextSteps: {path: '/nextSteps', crew: 'aim'},
                            twoYearChecks: {path: '/twoYearChecks', crew: 'aim'},
                            tally: {path: '/tally', crew: 'aim'},
                            groupObservation: {
                                path: '/groupObservation',
                                crew: 'aim',
                            },
                        },
                    },
                    bookings: {
                        path: '/bookings',
                        crew: 'finance',
                        subRoutes: {
                            purchases: {path: '/purchases', crew: 'finance'},
                        },
                    },
                    bookingPatternBuilder: {
                        path: '/bookingPatternBuilder',
                        crew: 'finance',
                    },
                    bulkPatternFlow: {
                        path: '/bulkPatternFlow',
                        crew: 'finance',
                    },
                    roomPlanning: {
                        path: '/roomPlanning',
                        crew: 'stat',
                    },
                    inquiriesV2: {
                        path: '/inquiries',
                        crew: 'stat',
                    },
                    occupancyReport: {
                        path: '/occupancyReport',
                        crew: 'stat',
                    },
                    occupancy: {
                        path: '/occupancy',
                        crew: 'stat',
                    },
                    forms: {
                        path: '/forms',
                        crew: 'stat',
                        subRoutes: {
                            newForm: {
                                path: '/newForm',
                                crew: 'stat',
                            },
                            formBuilder: {
                                path: '/builder/:formId',
                                crew: 'stat',
                            },
                            customInquiryFormAuthenticated: {
                                path: '/submit/:formId/for/:childId',
                                crew: 'stat',
                            },
                            submissionResponse: {
                                path: '/:formId/submissionResponse/:submissionId',
                                crew: 'stat',
                            },
                            formManagement: {
                                path: '/management',
                                crew: 'stat',
                            },
                        },
                    },
                    billingActivityOverview: {
                        path: '/billingActivityOverview',
                        crew: 'finance',
                    },
                    attendanceStatistics: {
                        path: '/attendanceStatistics',
                        crew: 'stat',
                    },
                    itemsAndPricing: {
                        path: '/itemsAndPricing',
                        crew: 'finance',
                    },
                    immunizations: {
                        path: '/immunizations',
                        crew: 'aim',
                        subRoutes: {
                            onboarding: {
                                path: '/onboarding',
                                crew: 'aim',
                            },
                        },
                    },
                    medicationForms: {
                        path: '/medicationForms',
                        crew: 'aim',
                    },
                    famlyPay: {
                        path: '/famlyPay',
                        crew: 'finance',
                        subRoutes: {
                            payouts: {
                                path: '/payouts',
                                crew: 'finance',
                            },
                            fees: {
                                path: '/fees',
                                crew: 'finance',
                            },
                        },
                    },
                    bulkImportPayment: {
                        path: '/importPayments',
                        crew: 'finance',
                        subRoutes: {
                            splitPayments: {
                                path: '/splitPayments/:paymentsFeedId',
                                crew: 'finance',
                            },
                            protoPayments: {
                                path: '/protoPayments/:paymentsFeedId',
                                crew: 'finance',
                            },
                        },
                    },
                    headcount: {
                        path: '/headcount',
                        crew: 'aim',
                    },
                    headcountReport: {
                        path: '/headcountReport',
                        crew: 'aim',
                    },
                    healthAndSafeguarding: {
                        path: '/healthAndSafeguarding',
                        crew: 'aim',
                        subRoutes: {
                            immunizations: {path: '/immunizations', crew: 'aim'},
                            medicationForms: {path: '/medicationForms', crew: 'aim'},
                            headcount: {path: '/headcount', crew: 'aim'},
                        },
                    },
                    safeguarding: {
                        path: '/safeguarding',
                        crew: 'aim',
                    },
                    openid: {
                        path: '/openid',
                        crew: 'aim',
                        subRoutes: {
                            createProvider: {path: '/createProvider', crew: 'aim'},
                        },
                    },
                    manageGroupRules: {
                        path: '/manageGroupRules',
                        crew: 'aim',
                    },
                    lessonPlans: {path: '/lessonPlans', crew: 'aim'},
                    curriculums: {
                        path: '/curriculums',
                        crew: 'aim',
                        subRoutes: {
                            create: {
                                path: '/create',
                                crew: 'aim',
                                subRoutes: {
                                    duplicate: {
                                        path: '/:curriculumId',
                                        crew: 'aim',
                                    },
                                },
                            },
                            show: {
                                path: '/:curriculumId',
                                crew: 'aim',
                            },
                        },
                    },
                    curriculumsList: {
                        path: '/curriculumsList',
                        crew: 'aim',
                        subRoutes: {
                            show: {
                                path: '/:curriculumId',
                                crew: 'aim',
                            },
                        },
                    },
                    manageEmployeeRights: {
                        path: '/manageEmployeeRights',
                        crew: 'aim',
                        subRoutes: {
                            index: {path: '/', crew: 'aim'},
                            roles: {path: '/roles', crew: 'aim'},
                            permissions: {path: '/permissions', crew: 'aim'},
                        },
                    },
                    employee: {
                        path: '/employee/:employeeId',
                        crew: 'stat',
                        subRoutes: {
                            employeeData: {
                                path: '/employeeData',
                                crew: 'stat',
                            },
                            employeeRelations: {
                                path: '/employeeRelations',
                                crew: 'stat',
                            },
                            employeeLeave: {
                                path: '/employeeLeave',
                                crew: 'stat',
                            },
                            about: {
                                path: '/about',
                                crew: 'stat',
                            },
                            employeeCalendar: {
                                path: '/employeeCalendar',
                                crew: 'stat',
                            },
                        },
                    },
                    childImport: {
                        path: '/childImport',
                        crew: 'aim',
                    },
                    childImportV2: {
                        path: '/child-import-v2',
                        crew: 'go',
                    },
                    kitaImport: {
                        path: '/kitaImport',
                        crew: 'aim',
                    },
                    kivanImport: {
                        path: '/kivanImport',
                        crew: 'aim',
                    },
                    kivanImportV2: {
                        path: '/kivan-import-v2',
                        crew: 'go',
                    },
                    staff: {
                        path: '/staff',
                        crew: 'aim', // TODO: is this correct?
                    },
                    children: {
                        path: '/children',
                        crew: 'aim',
                    },
                    noAccess: {
                        path: '/noAccess',
                        crew: 'aim',
                    },
                    financeOnboarding: {
                        path: '/financeOnboarding',
                        crew: 'growth',
                    },
                    /*
                        Since we added Famly Store to the institution routes, the link in the old nav was broken.
                        This was due to different way of handling routes and nav links in the old and new nav.
                        The solution is to keep both routes (at least for some time) until we are sure, nobody is on the old nav.
                    */
                    famlyStore: {
                        path: '/famlyStore',
                        subRoutes: {
                            packagePurchase: {
                                path: '/packagePurchase/:initialPackageId/:billingCycle',
                                crew: 'growth',
                            },
                            packagePricing: {
                                path: '/packagePricing',
                                crew: 'growth',
                            },
                            featureStore: {
                                path: '/featureStore',
                                crew: 'growth',
                            },
                            templates: {
                                path: '/templates',
                                crew: 'growth',
                            },
                        },
                        crew: 'growth',
                    },
                    contentReports: {
                        path: '/contentReports',
                        crew: 'aim',
                    },
                    financeLandingPage: {
                        path: '/financeLandingPage',
                        crew: 'growth',
                    },
                    attendanceLandingPage: {
                        path: '/attendanceLandingPage',
                        crew: 'growth',
                    },
                    learningLandingPage: {
                        path: '/learningLandingPage',
                        crew: 'growth',
                    },
                    childrenLandingPage: {
                        path: '/childrenLandingPage',
                        crew: 'growth',
                    },
                },
            },
            /*
            |---------------------------------------------------------------------------------
            | Organization routes
            |---------------------------------------------------------------------------------
            */
            organization: {
                path: '/organization/:organizationId',
                crew: 'aim',
                subRoutes: {
                    apiTokens: {
                        path: '/apiTokens',
                        crew: 'aim',
                    },
                    security: {
                        path: '/security',
                        crew: 'aim',
                        subRoutes: {
                            deviceEnrollment: {
                                path: '/deviceEnrollment',
                                crew: 'aim',
                            },
                        },
                    },
                    integrations: {
                        path: '/integrations',
                        crew: 'aim',
                        subRoutes: {
                            watchMeGrow: {
                                path: '/watchMeGrow',
                                crew: 'aim',
                            },
                        },
                    },
                    parentToDoLists: {
                        path: '/parentToDoLists',
                        crew: 'enr',
                        subRoutes: {
                            toDoList: {
                                path: '/list/:taskListId',
                                crew: 'enr',
                            },
                        },
                    },
                    billPayerTags: {
                        path: '/billPayerTags',
                        crew: 'payments',
                    },
                    automations: {
                        path: '/automations',
                        crew: 'growth',
                    },
                    openid: {
                        path: '/openid',
                        crew: 'aim',
                        subRoutes: {
                            createProvider: {
                                path: '/createProvider',
                                crew: 'aim',
                            },
                        },
                    },
                    inquiriesV2: {
                        path: '/inquiries',
                        crew: 'stat',
                    },
                    staffing: {
                        path: '/staffing',
                        crew: 'stat',
                        subRoutes: {
                            staffLeaveV2: {path: '/staffLeaveV2', crew: 'stat'},
                            staffHours: {
                                path: '/staffHours',
                                crew: 'stat',
                            },
                        },
                    },
                    settings: {
                        path: '/settings',
                        crew: 'aim',
                    },
                    // TODO: Is this used?
                    subscription: {
                        path: '/subscription',
                        crew: 'finance',
                    },
                    // TODO: Is this used?
                    manageEmployees: {
                        path: '/manageEmployees',
                        crew: 'aim', // TODO: Is this right?
                        subRoutes: {
                            overview: {
                                path: '/',
                                crew: 'aim',
                            },
                            roles: {
                                path: '/roles',
                                crew: 'aim',
                            },
                            permissions: {
                                path: '/permissions',
                                crew: 'aim',
                            },
                        },
                    },
                    newArea: {
                        path: '/newArea',
                        crew: 'aim',
                    },
                    revenueReport: {
                        path: '/revenueReport',
                        crew: 'finance',
                    },
                    billingActivityOverview: {
                        path: '/billingActivityOverview',
                        crew: 'finance',
                    },
                    payments: {
                        path: '/payments',
                        crew: 'finance',
                    },
                    invoicesReport: {
                        path: '/invoicesReport',
                        crew: 'finance',
                    },
                    billPayersReport: {
                        path: '/billPayersReport',
                        crew: 'finance',
                    },
                    directDebitsReport: {
                        path: '/directDebitsReport',
                        crew: 'finance',
                    },
                    occupancy: {
                        path: '/occupancy',
                        crew: 'stat',
                    },
                    occupancyReport: {
                        path: '/occupancyReport',
                        crew: 'stat',
                    },
                    publicFundingReport: {
                        path: '/publicFundingReport',
                        crew: 'finance',
                    },
                    balanceReport: {
                        path: '/balanceReport',
                        crew: 'finance',
                    },
                    insights: {
                        path: '/insights',
                        crew: 'aim',
                    },
                    organizationOverview: {
                        path: '/',
                        crew: 'aim',
                    },
                    dashboard: {
                        path: '/dashboard',
                        crew: 'aim',
                    },
                    contentReports: {
                        path: '/contentReports',
                        crew: 'aim',
                    },
                    // TODO: Is this used?
                    finance: {
                        path: '/finance',
                        crew: 'finance',
                    },
                    curriculums: {
                        path: '/curriculums',
                        crew: 'aim',
                        subRoutes: {
                            create: {
                                path: '/create',
                                crew: 'aim',
                                subRoutes: {
                                    duplicate: {
                                        path: '/:curriculumId',
                                        crew: 'aim',
                                    },
                                },
                            },
                            show: {
                                path: '/:curriculumId',
                                crew: 'aim',
                            },
                        },
                    },
                    curriculumsList: {
                        path: '/curriculumsList',
                        crew: 'aim',
                        subRoutes: {
                            show: {
                                path: '/:curriculumId',
                                crew: 'aim',
                            },
                        },
                    },
                    bulkImportPayment: {
                        path: '/importPayments',
                        crew: 'finance',
                        subRoutes: {
                            splitPayments: {
                                path: '/splitPayments/:paymentsFeedId',
                                crew: 'finance',
                            },
                            protoPayments: {
                                path: '/protoPayments/:paymentsFeedId',
                                crew: 'finance',
                            },
                        },
                    },
                },
            },
            loginAs: {
                path: '/loginAs',
                crew: 'aim',
            },
            endpointDebugging: {
                path: '/endpointDebugging',
                crew: 'aim',
            },
            financeDebugging: {
                path: '/financeDebugging',
                crew: 'finance',
                subRoutes: {
                    childId: {
                        path: '/:childId',
                        crew: 'finance',
                    },
                },
            },
            modernFamlyDebugging: {
                path: '/modernFamlyDebugging',
                crew: 'aim',
            },
        },
    },
} as const satisfies RouteConfigType;

export default RouteConfig;
